module.exports = __webpack_public_path__ + "static/media/logo-white.f35dff93.png";